<template>
  <div class="reportsettingpage">
    <h1>{{$t('SidebarMenu.Menu12')}}</h1>
    
    <div class="reportsettingforms">
      <div class="reportsettingforms-box">
        <div style="padding-bottom:30px">
          <el-tooltip content="请添加一个邮箱" :disabled="!switchdisabled" placement="top">
            <el-switch
              v-model="switchvalue"
              active-text="启用"
              inactive-text="暂停"
              active-color="#13ce66"
              inactive-color="#ccc"
              :disabled="switchdisabled"
              @change="changeswitchemail(switchvalue)">
            </el-switch>
          </el-tooltip>
        </div>

        <el-form size="small" label-width="110px" ref="dynamicValidateForm" :model="dynamicValidateForm" class="setemailfrom">
          <el-form-item
            v-for="(email, index) in dynamicValidateForm.email"
            :label='$t("Login.email") + (index+1)'
            :key="email.key"
            :prop="'email.' + index + '.value'"
            :rules="[
              { required: true, message: '请输入邮箱地址', trigger: 'blur' },
              { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change' }
            ]"
          >
            <el-input v-model="email.value"></el-input>
            <el-button v-if="dynamicValidateForm.email.length > 1" @click.prevent="removeDomain(email)">{{ $t("jgjk.s58") }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="setEmail('dynamicValidateForm')">{{ $t("activebrand.t15") }}</el-button>
            <el-button v-if="dynamicValidateForm.email.length < 5" @click="addDomain">{{ $t("activebrand.t111") }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data(){
    return{
      dynamicValidateForm: {
        email: [{
          value: ''
        }],
      },
      switchvalue: false,
      switchdisabled: true
    }
  },

  mounted(){
    this.getEmails()
  },
  
  methods: {

    changeswitchemail: function(mod){
      if(false === mod){
        this.$confirm('此操作将暂停日报发送功能，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeEmailStatus(0)
          this.$message({
            type: 'success',
            message: '日报发送功能已暂停'
          });
        }).catch(() => {
          this.switchvalue = true
          this.$message({
            type: 'info',
            message: '日报发送功能未暂停'
          });          
        });  
      }    
      if(true === mod){
        this.$confirm('此操作将启用日报发送功能，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeEmailStatus(1)
          this.$message({
            type: 'success',
            message: '日报发送功能已启用'
          });
        }).catch(() => {
          this.switchvalue = false
          this.$message({
            type: 'info',
            message: '日报发送功能未启用'
          });          
        });  
      }  
    },
    
    removeDomain(item) {
      var index = this.dynamicValidateForm.email.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.email.splice(index, 1)
      }
    },

    addDomain() {
      this.dynamicValidateForm.email.push({
        value: '',
        key: Date.now()
      })
    },

    /**
     * 提交邮箱
     */
    setEmail: function(formName){
      let that = this
      let emails = that.dynamicValidateForm.email
      let emailsarr = []
      for(let i=0; i<emails.length; i++){
        emailsarr[i] = emails[i].value
      }
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let url = that.API_URL + '/v3/notification/set'
          let query = {notifier: JSON.stringify(emailsarr)}
          $.ajax({
            url: url,
            type: "PUT",
            headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
            changeOrigin: true,
            crossDomain: true,
            data: query,
            success: function(data) {
              console.log('setEmail', data)
              that.$message({
                type: 'success',
                message: '邮箱添加成功！'
              });
              that.getEmails()
            },
            error: function(response) {
              console.log('setEmail', response)
            }
          })
        } else {
          return false;
        }
      })
    },

    /**
     * 获取邮箱
     */
    getEmails:function(){
      let that = this
      let url = that.API_URL + '/v3/notification/view'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          console.log('getEmails', data)
          if(data.result.length === 0) return
          let emails = data.result[0].notifier
          let resc0 = emails.substr(1)
          let resc1 = resc0.substr(0, resc0.length-1)
          let resc2 = JSON.parse(''+ resc1 +'')
          let emailsarr = []
          if(resc2.length > 0){
            that.switchdisabled = false
          }
          for(let i=0; i<resc2.length; i++){
            let _obj = {}
            _obj.value = resc2[i]
            emailsarr.push(_obj)
          }
          that.dynamicValidateForm.email = emailsarr
          that.switchvalue = data.result[0].status === 0 ? false : true
        },
        error: function(response) {
          console.log('getEmails', response)
        }
      })
    },

    /**
     * 改变日报状态
     */
    changeEmailStatus: function(statusid){
      let that = this
      let url = that.API_URL + '/v3/notification/status'
      let query = {start: statusid}
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('changeEmailStatus', data)
        },
        error: function(response) {
          console.log('changeEmailStatus', response)
        }
      })
    }

  }

}
</script>
